import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import About from './pages/About';
import Careers from './pages/Careers';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Security from './pages/Security';
import Drilling from './pages/features/Drilling';
import Blasting from './pages/features/Blasting';
import Revenue from './pages/features/Revenue';
import Cashflow from './pages/features/Cashflow';
import Reporting from './pages/features/Reporting';

function App() {
  const APP_URL = import.meta.env.VITE_APP_URL || 'https://app.mineoptics.com';

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />

          {/* Feature Pages */}
          <Route path="/features/drilling" element={<Drilling />} />
          <Route path="/features/blasting" element={<Blasting />} />
          <Route path="/features/revenue" element={<Revenue />} />
          <Route path="/features/cashflow" element={<Cashflow />} />
          <Route path="/features/reporting" element={<Reporting />} />

          {/* Company Pages */}
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />

          {/* Legal Pages */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/security" element={<Security />} />

          {/* Redirect auth routes to app subdomain */}
          <Route path="/auth/*" element={<Navigate to={`${APP_URL}/auth/login`} replace />} />

          {/* Redirect dashboard to app subdomain */}
          <Route path="/dashboard/*" element={<Navigate to={`${APP_URL}/dashboard`} replace />} />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
